import React from 'react';
import { Link } from 'react-router-dom';
import { Leaf, Phone, Mail } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="bg-[#2C3E2D] text-white mt-24">
      <div className="container py-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {/* About */}
          <div>
            <div className="flex items-center gap-2 mb-4">
              <div className="w-8 h-8 bg-[#D97706] rounded-full flex items-center justify-center">
                <Leaf className="w-4 h-4 text-white" />
              </div>
              <span className="text-lg font-bold" style={{ fontFamily: 'Heebo, sans-serif' }}>
                בריאות הגבר
              </span>
            </div>
            <p className="text-stone-300 leading-relaxed">
              האתר המוביל בישראל למוצרים ומידע מקצועי בתחום בריאות הגבר
            </p>
          </div>
          
          {/* Quick Links */}
          <div>
            <h3 className="text-lg font-semibold mb-4" style={{ fontFamily: 'Heebo, sans-serif' }}>
              קישורים מהירים
            </h3>
            <ul className="space-y-2">
              <li>
                <Link to="/products" className="text-stone-300 hover:text-[#D97706] transition-colors">
                  מוצרים
                </Link>
              </li>
              <li>
                <Link to="/articles" className="text-stone-300 hover:text-[#D97706] transition-colors">
                  מאמרים
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-stone-300 hover:text-[#D97706] transition-colors">
                  אודות
                </Link>
              </li>
              <li>
                <Link to="/terms" className="text-stone-300 hover:text-[#D97706] transition-colors">
                  תקנון אתר
                </Link>
              </li>
            </ul>
          </div>
          
          {/* Contact & Payment */}
          <div>
            <h3 className="text-lg font-semibold mb-4" style={{ fontFamily: 'Heebo, sans-serif' }}>
              צור קשר
            </h3>
            <div className="space-y-3 mb-6">
              <a 
                href="https://wa.me/972539406051?text=היי,+הגעתי+דרך+האתר+ואשמח+למידע+נוסף"
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center gap-2 text-stone-300 hover:text-[#25D366] transition-colors"
              >
                <Phone className="w-4 h-4" />
                <span>053-940-6051</span>
              </a>
              <div className="flex items-center gap-2 text-stone-300">
                <Mail className="w-4 h-4" />
                <span>menshealth.il12345@gmail.com</span>
              </div>
            </div>
            
            <div>
              <p className="text-sm text-stone-300 mb-2">אמצעי תשלום:</p>
              <div className="flex items-center gap-3 text-sm text-stone-400">
                <span>PayPal</span>
                <span>•</span>
                <span>כרטיס אשראי</span>
                <span>•</span>
                <span>ביט</span>
                <span>•</span>
                <span>מזומן</span>
              </div>
            </div>
          </div>
        </div>
        
        {/* Secure Payment Badge */}
        <div className="flex flex-col items-center mt-8 pt-6 border-t border-stone-600 gap-4">
          <img
            src="https://customer-assets.emergentagent.com/job_d56f6086-1f6c-43f9-a07d-5d56a502df97/artifacts/vhi6op6d_images.png"
            alt="תשלום מאובטח באשראי - Visa, MasterCard, ישראכרט"
            className="h-16 md:h-20 object-contain"
            data-testid="footer-secure-payment-badge"
          />
          <div className="flex items-center gap-6">
            <img
              src="https://customer-assets.emergentagent.com/job_d56f6086-1f6c-43f9-a07d-5d56a502df97/artifacts/swtwhshi_605f627f049b4fbfae856e43_download.png"
              alt="Upay"
              className="h-10 md:h-12 object-contain"
              data-testid="footer-upay-logo"
            />
            <img
              src="https://customer-assets.emergentagent.com/job_d56f6086-1f6c-43f9-a07d-5d56a502df97/artifacts/9o3frry2_%D7%94%D7%95%D7%A8%D7%93%D7%94.png"
              alt="קארדקום"
              className="h-10 md:h-12 object-contain"
              data-testid="footer-cardcom-logo"
            />
          </div>
        </div>
        
        <div className="border-t border-stone-600 mt-8 pt-8 text-center text-stone-400 text-sm">
          <p>© 2025 בריאות הגבר. כל הזכויות שמורות.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;